import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=a55d533e&scoped=true&"
import script from "./SendNotification.vue?vue&type=script&lang=ts&"
export * from "./SendNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=a55d533e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d533e",
  null
  
)

export default component.exports